import { useState, useEffect } from "react";
import { getDadoBancario } from "../../../api/Cadastro";
import Controle from "../ControleCamposMultiplos";
import { TextFieldsTwoTone } from "@mui/icons-material";

export default function DadoBancarioItem({
  fieldErrors,
  idCliente,
  idPerfilLimiteOperacional,
  setDada,
}) {
  const [dadosForm, setDadosForm] = useState({});
  const [dadosDefault, setDadosDefault] = useState({});

  useEffect(() => {
    init();
  }, []);

  const init = async () => {
    const response = await getDadoBancario(
      idCliente,
      idPerfilLimiteOperacional
    );

    setDadosDefault(() => ({ ...response[0] }));
    setDadosForm(() => [...response]);
    setDada(() => [...response]);
  };

  return (
    <>
      <Controle
        fieldErrors={fieldErrors}
        identificaItem="Dados Bancários"
        dadosForm={dadosForm}
        setDadosForm={setDadosForm}
        setData={setDada}
        defaultDadosForm={dadosDefault}
        title="Dados Bancários"
        setIdTipoEstadoCivil={null}
        tooltipAdd="Adicione um novo dado Bancário"
        tooltipDelete="Remove o dado bancário selecionada"
        initBuscaCampos={init}
      />
    </>
  );
}
